
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import Cookies from "js-cookie";

const BaseURL = process.env.REACT_APP_API_URL;
const token = Cookies.get("authToken");

const DataBase = Cookies.get("Database");
const ProjectIDs = 1;

export const LedgerNormal = createAsyncThunk(
    'Ledger/LedgerNormal',
    async (data) => {
        try {
            const response = await axios.post(`${BaseURL}/Ledger/LedgerNormal`, {
                FirmIDs: data.Firm,
                DataBase: DataBase,
                ProjectIDs: ProjectIDs,
                AcYearIDs: data.Year,
                StartDate: data.startDate ? data.startDate : "",
                EndDtate: data.endDate ? data.endDate : "",
                AcGroupIDs: data.selectedIds ? data.selectedIds : "",
                AcIDs: data.AcIDs ? data.AcIDs : "",
            }, {
                headers: {
                    token: token,
                    'Content-Type': 'application/json',
                    'Cache-Control': 'no-cache',
                },
            });
            return response.data;
        } catch (error) {
            throw new Error(error.response ? error.response.data : 'Network Error');
        }
    }
);

export const AcGroupList = createAsyncThunk(
    'FAS/AcGroupList',
    async (data) => {

        try {
            const response = await axios.post(`${BaseURL}/FAS/AcGroupList`, {
                FirmIDs: data.Firm,
                AcYearIDs: data.Year,
                DataBase: DataBase,
                ProjectIDs: ProjectIDs,
            }, {
                headers: {
                    token: token,
                    'Content-Type': 'application/json',
                    'Cache-Control': 'no-cache',
                },
            });
            return response.data;
        } catch (error) {
            throw new Error(error.response ? error.response.data : 'Network Error');
        }
    }
);



export const AcList = createAsyncThunk(
    'FAS/AcList',
    async (data) => {
        try {
            const response = await axios.post(`${BaseURL}/FAS/AcList`, {
                FirmIDs: data.Firm,
                DataBase: DataBase,
                ProjectIDs: ProjectIDs,
                AcYearIDs: data.Year ? data.Year : "",
                AcGroupIDs: data.selectedIds ? data.selectedIds : "",
                ProductionGroupMstIDs: data.selectedIds1 ? data.selectedIds1 : "",
            }, {
                headers: {
                    token: token,
                    'Content-Type': 'application/json',
                    'Cache-Control': 'no-cache',
                },
            });
            return response.data;
        } catch (error) {
            throw new Error(error.response ? error.response.data : 'Network Error');
        }
    }
);

export const FasAcList = createAsyncThunk(
    'FAS/FasAcList',
    async (data) => {

        try {
            const response = await axios.post(`${BaseURL}/FAS/FasAcList`, {
                AcYearIDs: data.Year,
                DataBase: DataBase,
                ProjectIDs: ProjectIDs,
                AcIDs: data.AcIDs ? data.AcIDs : "",
                AcGroupIDs: data.AcGroupIDs ? data.AcGroupIDs : "",
                FirmIDs: data.Firm,

            }, {
                headers: {
                    token: token,
                    'Content-Type': 'application/json',
                    'Cache-Control': 'no-cache',
                },
            });
            return response.data;
        } catch (error) {
            throw new Error(error.response ? error.response.data : 'Network Error');
        }
    }
);


export const LedgerMultiYear = createAsyncThunk(
    'Ledger/LedgerMultiYear',
    async (data) => {

        try {
            const response = await axios.post(`${BaseURL}/Ledger/LedgerMultiYear`, {
                FirmIDs: data.Firm,
                DataBase: DataBase,
                ProjectIDs: ProjectIDs,
                AcYearIDs: data.Year,
                AcGroupIDs: data.selectedIds ? data.selectedIds : "",
                AcIDs: data.AcIDs ? data.AcIDs : "",
                StartDate: data.startDate ? data.startDate : "",
                EndDtate: data.endDate ? data.endDate : "",
            }, {
                headers: {
                    token: token,
                    'Content-Type': 'application/json',
                    'Cache-Control': 'no-cache',
                },
            });
            return response.data;
        } catch (error) {
            throw new Error(error.response ? error.response.data : 'Network Error');
        }
    }
);

export const LedgerOpening = createAsyncThunk(
    'Ledger/LedgerOpening',
    async (data) => {
        try {
            const response = await axios.post(`${BaseURL}/Ledger/LedgerOpening`, {
                FirmIDs: data.Firm,
                DataBase: DataBase,
                ProjectIDs: ProjectIDs,
                AcYearIDs: data.Year,
                AcGroupIDs: data.selectedIds ? data.selectedIds : "",
                AcIDs: data.AcIDs ? data.AcIDs : "",
                StartDate: data.startDate ? data.startDate : "",

            }, {
                headers: {
                    token: token,
                    'Content-Type': 'application/json',
                    'Cache-Control': 'no-cache',
                },
            });
            return response.data;
        } catch (error) {
            throw new Error(error.response ? error.response.data : 'Network Error');
        }
    }
);

export const Ledgersummary = createAsyncThunk(
    'Ledger/LedgerSummery',
    async (data) => {
        try {
            const response = await axios.post(`${BaseURL}/Ledger/LedgerSummery`, {
                FirmIDs: data.Firm,
                DataBase: DataBase,
                ProjectIDs: ProjectIDs,
                AcYearIDs: data.Year,
                StartDate: data.startDate ? data.startDate : "",
                EndDtate: data.endDate ? data.endDate : "",
                AcGroupIDs: data.selectedIds ? data.selectedIds : "",
                AcIDs: data.AcIDs ? data.AcIDs : "",
            }, {
                headers: {
                    token: token,
                    'Content-Type': 'application/json',
                    'Cache-Control': 'no-cache',
                },
            });
            return response.data;
        } catch (error) {
            throw new Error(error.response ? error.response.data : 'Network Error');
        }
    }
);

export const LedgerMasterAC = createAsyncThunk(
    'Ledger/LedgerMasterAC',
    async (data) => {
        try {
            const response = await axios.post(`${BaseURL}/Ledger/LedgerMasterAC`, {
                FirmIDs: data.Firm,
                DataBase: DataBase,
                ProjectIDs: ProjectIDs,
                AcYearIDs: data.Year,
                StartDate: data.startDate ? data.startDate : "",
                EndDtate: data.endDate ? data.endDate : "",
                AcGroupIDs: data.selectedIds ? data.selectedIds : "",
                AcIDs: data.AcIDs ? data.AcIDs : "",
            }, {
                headers: {
                    token: token,
                    'Content-Type': 'application/json',
                    'Cache-Control': 'no-cache',
                },
            });
            return response.data;
        } catch (error) {
            throw new Error(error.response ? error.response.data : 'Network Error');
        }
    }
);

export const LedgerMasterAccountList = createAsyncThunk(
    'Ledger/LedgerMasterAccountList',
    async (data) => {
        try {
            const response = await axios.post(`${BaseURL}/Ledger/LedgerMasterAccountList`, {
                FirmIDs: data.Firm,
                DataBase: DataBase,
                ProjectIDs: ProjectIDs,
                AcYearIDs: data.Year,
                MasterAcIDs: data.selectedIds ? data.selectedIds : "",
                AcIDs: data.AcIDs ? data.AcIDs : "",
            }, {
                headers: {
                    token: token,
                    'Content-Type': 'application/json',
                    'Cache-Control': 'no-cache',
                },
            });
            return response.data;
        } catch (error) {
            throw new Error(error.response ? error.response.data : 'Network Error');
        }
    }
);

export const LedgerSlice = createSlice({
    name: 'FAS',
    initialState: {
        LedgerNormaldata: null,
        AcGroupListdata: null,
        LedgerMultiYeardata: null,
        LedgerOpeningdata: null,
        Ledgersummarydata: null,
        LedgerMasterACdata: null,
        AcListdata: null,
        FasAcListdata: null,
        LedgerMasterAccountListdata: null,
        status: 'idle',
        error: null,
    },
    reducers: {
        resetLedgerData: (state) => {
            state.FasAcList = null;
        },
        AccountFun: (state) => {
            state.LedgerNormaldata = "no";
        },
        MultiYearFun: (state) => {
            state.LedgerMultiYeardata = "no";
        },
        OpeningFun: (state) => {
            state.LedgerOpeningdata = "no";
        },
        SummaryFun: (state) => {
            state.Ledgersummarydata = "no";
        },
        AcConfirmationFun: (state) => {
            state.Ledgersummarydata = "no";
        },
        MasterACFun: (state) => {
            state.LedgerMasterACdata = "no";
        },

    },
    extraReducers: (builder) => {
        builder
            .addCase(LedgerNormal.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(LedgerNormal.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.LedgerNormaldata = action.payload;
            })
            .addCase(LedgerNormal.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            })


            .addCase(AcGroupList.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(AcGroupList.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.AcGroupListdata = action.payload;
            })
            .addCase(AcGroupList.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            })


            .addCase(AcList.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(AcList.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.AcListdata = action.payload;
            })
            .addCase(AcList.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            })

            .addCase(LedgerMultiYear.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(LedgerMultiYear.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.LedgerMultiYeardata = action.payload;
            })
            .addCase(LedgerMultiYear.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            })


            .addCase(LedgerOpening.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(LedgerOpening.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.LedgerOpeningdata = action.payload;
            })
            .addCase(LedgerOpening.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            })

            .addCase(Ledgersummary.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(Ledgersummary.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.Ledgersummarydata = action.payload;
            })
            .addCase(Ledgersummary.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            })

            .addCase(LedgerMasterAC.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(LedgerMasterAC.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.LedgerMasterACdata = action.payload;
            })
            .addCase(LedgerMasterAC.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            })


            .addCase(FasAcList.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(FasAcList.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.FasAcListdata = action.payload;
            })
            .addCase(FasAcList.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            })


            .addCase(LedgerMasterAccountList.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(LedgerMasterAccountList.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.LedgerMasterAccountListdata = action.payload;
            })
            .addCase(LedgerMasterAccountList.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            })



    },
});

export const { resetLedgerData, AccountFun, MultiYearFun, OpeningFun, SummaryFun, AcConfirmationFun, MasterACFun } = LedgerSlice.actions;

export default LedgerSlice.reducer;

